import type { ProductItem } from '@/common/types/product.type';
import { type ResponseItemType } from '@/common/types/response.type';
import { useQuery } from '@tanstack/react-query';

import Client from '@/common/utils/client.utility';
import serializeIdentifier from '@/common/utils/serialize-identifier.utility';

export interface StoreProductItemQueryParams {
  identifier: string;
  id: number;
}

export interface StoreProductItemResponse extends ProductItem {}

export type ProductItemType = (
  params: StoreProductItemQueryParams,
  disabelToast?: boolean
) => Promise<ResponseItemType<StoreProductItemResponse>>;

export const getStoreProductItem: ProductItemType = async (
  params,
  disableToast
) => {
  const client = new Client(disableToast);
  const { identifier, id } = params;
  const slug = serializeIdentifier(identifier);

  // eslint-disable-next-line sonarjs/no-nested-template-literals
  const endpoint = `/v1/Shopper/Storefronts${slug ? `/${slug}` : ''}/Product/${id}`;
  return await client.get(endpoint);
};

export function useGetStoreProductItem({
  enabled,
  query,
  disableToast = false,
}: {
  enabled?: boolean;
  query: StoreProductItemQueryParams;
  disableToast?: boolean;
}) {
  return useQuery<
    ResponseItemType<StoreProductItemResponse>,
    Error,
    StoreProductItemResponse
  >({
    queryFn: async () => await getStoreProductItem(query, disableToast),
    queryKey: ['store-product-item', query],
    retry: 2,
    enabled,
    select: (data) => data.data,
    staleTime: 600000,
  });
}
